const ufeApi = require('services/api/ufeApi');

// https://jira.sephora.com/browse/CE-286

function submitEmailSMSOptInForm(payload) {
    const url = '/api/util/OptinEmailSms';

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(payload)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = { submitEmailSMSOptInForm };
